import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Logo, Shield, EyeOff, Lock, ArrowLeft } from '../Icons';
import './Auth.css';

const points = [
  { Icon: EyeOff, text: 'Your contact details stay hidden from browsing senders' },
  { Icon: Shield, text: 'Every assignment is reviewed by our admin team' },
  { Icon: Lock, text: 'Payments are held securely until assignment' },
];

export default function AuthLayout({ title, subtitle, children, footer }) {
  useEffect(() => {
    document.title = `${title} | Routebag`;
  }, [title]);

  return (
    <div className="auth">
      <aside className="auth__panel" aria-hidden="true">
        <div className="auth__panel-bg">
          <div className="auth__orb auth__orb--a" />
          <div className="auth__orb auth__orb--b" />
        </div>
        <Link to="/" className="brand brand--light" tabIndex={-1}>
          <Logo />
          <span>Routebag</span>
        </Link>

        <div className="auth__panel-copy">
          <h2>Send with people already going your way.</h2>
          <p>Connect with verified travellers on your route, with privacy and safety built in.</p>
          <ul>
            {points.map(({ Icon, text }) => (
              <li key={text}>
                <span><Icon width={18} height={18} /></span>
                {text}
              </li>
            ))}
          </ul>
        </div>

        <div className="auth__route">
          <div><small>From</small><strong>BOM</strong></div>
          <div className="auth__route-line" />
          <div><small>To</small><strong>DXB</strong></div>
          <span className="auth__route-cap">8 kg free</span>
        </div>
      </aside>

      <main className="auth__main">
        <div className="auth__top">
          <Link to="/" className="brand auth__brand-mobile">
            <Logo />
            <span>Routebag</span>
          </Link>
          <Link to="/" className="auth__back">
            <ArrowLeft width={16} height={16} /> Back to home
          </Link>
        </div>

        <div className="auth__card">
          <header className="auth__head">
            <h1>{title}</h1>
            {subtitle && <p>{subtitle}</p>}
          </header>
          {children}
        </div>

        {footer && <p className="auth__footer">{footer}</p>}
      </main>
    </div>
  );
}
